import {
  getPromotionDetailFn,
  type DefaultQueryError,
  type Promotion,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetPromotionDetail = (
  promo_code: string,
  opts?: Omit<UseQueryOptions<Promotion, DefaultQueryError>, 'queryKey'>
) =>
  useQuery<Promotion, DefaultQueryError>({
    queryKey: [promo_code, 'promo_detail'],
    queryFn: () => getPromotionDetailFn(promo_code),
    ...opts,
  });
